if (!customElements.get('cart-terms-gate')) {
  customElements.define('cart-terms-gate', class extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.modal = document.getElementById(this.dataset.modalId);
      this.form = this.closest('form');
      if (!this.checkbox || !this.modal || !this.form) {
        console.warn('[cart-terms-gate] missing dependency', { checkbox: !!this.checkbox, modal: !!this.modal, form: !!this.form });
        return;
      }

      this.checkoutBtn = this.form.querySelector('button[name="button"], button[name="checkout"]');
      if (!this.checkoutBtn) return;

      this.syncButton();

      this.checkbox.addEventListener('change', () => this.syncButton());

      this.checkoutBtn.addEventListener('click', (event) => {
        if (this.checkbox.checked) return;
        event.preventDefault();
        this.modal.show();
      });

      this.modal.querySelector('[data-cart-terms-accept]')?.addEventListener('click', () => {
        this.checkbox.checked = true;
        this.syncButton();
        this.modal.hide();
        requestAnimationFrame(() => this.checkoutBtn.click());
      });
    }

    syncButton() {
      if (this.checkbox.checked) {
        this.checkoutBtn.name = 'checkout';
        this.checkoutBtn.type = 'submit';
      } else {
        this.checkoutBtn.name = 'button';
        this.checkoutBtn.type = 'button';
      }
    }
  });
}
